import { createApi } from "@reduxjs/toolkit/query/react"
import baseQuery from "./api"
import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions"
import { ApiSlug } from "../utils/enums/ApiSlug"

export const questionServiceApi = createApi({
  reducerPath: "questionService",
  baseQuery: baseQuery,
  tagTypes: [],
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    getQuestions: builder.query({
      query: (assessmentCategoryId: string) => ({
        url: ApiSlug.GET_ALL_QUESTIONS.replace(
          "{assessmentCategoryId}",
          assessmentCategoryId,
        ),
        method: "GET",
      }),
    }),
  }),
})

export const { useLazyGetQuestionsQuery } = questionServiceApi
